import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { ToastContainer,toast } from "react-toastify";
import { Months, YEARS } from "./constants";
import { storeAchivements } from "./databasefunctions";
import './forms.css'
import { useSelector } from "react-redux";
import Message from "../Message";


const Pressform = ({handleupdate}) => {
    const years = YEARS();
    const months = Months
    const [message, setMessage] = useState(null)
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));

    const [achivements, setAchivements] = useState({
        title: '',
        presstitle: '',
        month: months[0],
        year: years[0],
        author: '',
        sourceUrl: '',
        description: ''
    })
    const notify = () => toast.success("Succesfully Updated");
    const Finish = () => {
        if (achivements.title == '') {

            setMessage('Title is Required')
        }
        else {
            storeAchivements(currentUser.uid, 'Press', achivements)
            setMessage(null)
            notify()
            handleupdate()
        }
    }
    return (<div id='container'>
        <Row >
            <Col md='12' sm='12'>
                <div className='fs-14 fw-bold mb-0' style={{ marginTop: '8px' }}>
                    Press
                </div>
            </Col>
            <Col md='12' sm='12'>
                <label
                    htmlFor="achievemnt"
                    className="form-label fw-semibold fs-13 text-muted"
                    style={{ marginTop: '8px' }}

                >
                    Title *

                </label>
            </Col>
            <Col md='12' sm='12'>
                <input
                    type="text"
                    className="form-control form-control-lg"
                    name="achivement"
                    placeholder="Title"
                    onChange={(e) => setAchivements({ ...achivements, title: e.target.value })}
                />

            </Col>
            <Col md='12' sm='12'>
                <div style={{ marginTop: '8px' }}>
                    {message && (
                        <Message variant="danger">{message}</Message>
                    )}
                </div>
            </Col>
            <Col md='12' sm='12'>
                <label
                    htmlFor="achievemnt"
                    className="form-label fw-semibold fs-13 text-muted"
                    style={{ marginTop: '8px' }}

                >
                    Press Title

                </label>
            </Col>
            <Col md='12' sm='12'>
                <input
                    type="text"
                    className="form-control form-control-lg"
                    name="achivement"
                    placeholder="Press Title"
                    onChange={(e) => setAchivements({ ...achivements, presstitle: e.target.value })}
                />

            </Col>

            <Col md='12' sm='12'>
                <label
                    htmlFor="achievemnt"
                    className="form-label fw-semibold fs-13 text-muted"
                    style={{ marginTop: '8px' }}

                >
                    Issue Date

                </label>
            </Col>
            <Col md='6' sm='12'>
                <select

                    className="form-select form-select-lg form-control"
                    id="inputmanagement"
                    onChange={(e) => setAchivements({ ...achivements, month: e.target.value })}
                >
                    {months.map((month) => (
                        <option key={month} value={month}>
                            {month}
                        </option>
                    ))}
                </select>

            </Col>

            <Col md='6' sm='12'>
                <select

                    className="form-select form-select-lg form-control"
                    id="inputmanagement"
                    onChange={(e) => setAchivements({ ...achivements, year: e.target.value })}
                >
                    {years.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>

            </Col>
            <Col md='12' sm='12'>
                <label
                    htmlFor="achievemnt"
                    className="form-label fw-semibold fs-13 text-muted"
                    style={{ marginTop: '8px' }}

                >
                    Author

                </label>
            </Col>
            <Col md='12' sm='12'>
                <input
                    type="text"
                    className="form-control form-control-lg"
                    name="achivement"
                    placeholder="Author"
                    onChange={(e) => setAchivements({ ...achivements, author: e.target.value })}
                />

            </Col>
            <Col md='12' sm='12'>
                <label
                    htmlFor="achievemnt"
                    className="form-label fw-semibold fs-13 text-muted"
                    style={{ marginTop: '8px' }}
                >
                    Source URL

                </label>
            </Col>
            <Col md='12' sm='12'>
                <input
                    type="text"
                    className="form-control form-control-lg"
                    name="source"
                    placeholder="Source URL"
                    onChange={(e) => setAchivements({ ...achivements, sourceUrl: e.target.value })}
                />

            </Col>
            <Col md='12' sm='12'>
                <label
                    htmlFor="achievemnt"
                    className="form-label fw-semibold fs-13 text-muted"
                    style={{ marginTop: '8px' }}
                >
                    Description

                </label>
            </Col>
            <Col md='12' sm='12'>
                <textarea class="form-control" onChange={(e) => setAchivements({ ...achivements, description: e.target.value })} id="exampleFormControlTextarea1" rows="3"></textarea>

            </Col>
            <Col md='3' sm='3'>

                <button type="button" className="btn btn-primary rounded-pill fw-semibold px-4" onClick={() => Finish()} style={{ marginTop: '8px', marginBottom: '8px' }}>
                    <ToastContainer />
                    Save
                </button>
            </Col>

        </Row>

    </div>);
}
export default Pressform